import * as React from 'react';
import { AnalyticsProvider, AnalyticsTrigger, Button, Grid, GridColumn, Heading, IButtonProps, Separator } from 'telia-front-react';

export interface IAdditionalInformationProps {
  children: React.ReactNode;
  title: string;
  headingLevel?: 1 | 2 | 3 | 4 | 5 | 6;
  showTitle?: boolean;
  button?: IButtonProps;
}

class AdditionalInformation extends React.Component<IAdditionalInformationProps> {
  public render() {
    const { children, title, showTitle = true, headingLevel = 2, button } = this.props;
    const headingClassName = ['text-center'];

    if (!showTitle) {
      headingClassName.push('sr-only');
    }

    return (
      <AnalyticsProvider group="Additional Information">
        <Heading element={`h${headingLevel}` as any} className={headingClassName.join(' ')}>
          {title}
        </Heading>
        <Separator color="invisible" spacing="small" />
        <Grid align={['center-xs']}>
          <GridColumn width={['sm-11', 'md-9']} noGutter={false}>
            {children}
          </GridColumn>
        </Grid>
        {button && (
          <>
            <Separator color="invisible" spacing="small" />
            <p className="text-center">
              <AnalyticsTrigger trigger={{ callback: 'onClick', id: 'Button - Vaata lähemalt' }}>
                <Button {...button} />
              </AnalyticsTrigger>
            </p>
          </>
        )}
      </AnalyticsProvider>
    );
  }
}

export default AdditionalInformation;
